/**
 * Deep-merge plain objects. Arrays and primitives from `source` replace `target`.
 */
export function deepMerge(target, source) {
  if (source === null || source === undefined) {
    return target;
  }
  if (typeof source !== "object" || Array.isArray(source)) {
    return source;
  }
  const base =
    target && typeof target === "object" && !Array.isArray(target) ? { ...target } : {};
  for (const key of Object.keys(source)) {
    const sv = source[key];
    const tv = base[key];
    if (sv && typeof sv === "object" && !Array.isArray(sv)) {
      base[key] = deepMerge(tv && typeof tv === "object" && !Array.isArray(tv) ? tv : {}, sv);
    } else {
      base[key] = sv;
    }
  }
  return base;
}
